import * as RootNavigation from '../../utils/navigationRef';
import { Screens } from '../../constants/ScreenNames';
import {
  selectActiveComponentIndex,
  selectSearchOriginScreen,
  selectTripResults,
} from '../selectors/search.selector';

export const MOVE_NEXT = 'MOVE_NEXT';
export const MOVE_PREVIOUS = 'MOVE_PREVIOUS';
export const MOVE_PREVIOUS_HOTEL_DETAIL = 'MOVE_PREVIOUS_HOTEL_DETAIL';
import { REBOOK_ENABLED, AA_ENABLED } from '../../config/env.js';

const componentNameMap = {
  air: Screens.Flight,
  airCloud: Screens.FlightCloud,
  hotel: Screens.Hotel,
  car: Screens.Car,
  rail: Screens.Rail,
  tripsummary: Screens.Passenger, // skipping tripsummary screen
};

export const moveNext = (searchOriginScreen, changeRes) => {
  return async (dispatch, getState) => {
    const tripResults = selectTripResults(getState());
    const activeComponentIndex = selectActiveComponentIndex(getState());
    const airReqComponentRedisKey = tripResults?.IsAirCloud
      ? tripResults?.IsAirCloud
      : tripResults?.RequestedComponents?.find((x) => x.DisplayIndex === activeComponentIndex + 1)
          ?.RedisCacheKey;

    if (tripResults) {
      const nextStep = tripResults.RequestedComponents.find(
        (x) => x.DisplayIndex === activeComponentIndex + 1
      );
      if (nextStep) {
        dispatch({
          type: MOVE_NEXT,
          nextStep,
          searchOriginScreen,
        });

        if (nextStep.ComponentName === 'air' || nextStep.ComponentName === 'rail') {
          if (changeRes) {
            RootNavigation.navigate(componentNameMap[nextStep.ComponentName], {
              legNumber: nextStep.LegNumber,
              selectedAwardCode: tripResults.SelectedAward,
            });
          } else {
            if (airReqComponentRedisKey) {
              RootNavigation.push(componentNameMap.airCloud, {
                legNumber: nextStep.LegNumber,
                selectedAwardCode: tripResults.SelectedAward,
              });
            } else {
              RootNavigation.push(componentNameMap[nextStep.ComponentName], {
                legNumber: nextStep.LegNumber,
                selectedAwardCode: tripResults.SelectedAward,
              });
            }
          }
        } else {
          RootNavigation.push(componentNameMap[nextStep.ComponentName]);
        }
      }
    }
  };
};

export const movePrevious = () => {
  return async (dispatch, getState) => {
    const tripResults = selectTripResults(getState());
    const activeComponentIndex = selectActiveComponentIndex(getState());
    const searchOriginScreen = selectSearchOriginScreen(getState());
    const airReqComponentRedisKey = tripResults?.IsAirCloud
      ? tripResults?.IsAirCloud
      : tripResults?.RequestedComponents?.find((x) => x.DisplayIndex === activeComponentIndex + 1)
          ?.RedisCacheKey;

    if (tripResults) {
      if (activeComponentIndex === 1) {
        if (searchOriginScreen) {
          RootNavigation.navigate(searchOriginScreen);
        } else {
          if (REBOOK_ENABLED) {
            RootNavigation.navigate(Screens.RebookHome);
          } else if (AA_ENABLED) {
            RootNavigation.navigate(Screens.AASearchScreen);
          } else {
            RootNavigation.navigate(Screens.Home);
          }
        }
      }
      const previousStep = tripResults.RequestedComponents.find(
        (x) => x.DisplayIndex === activeComponentIndex - 1
      );
      if (previousStep) {
        if (previousStep.ComponentName === 'hotel') {
          dispatch(movePreviousHotelDetail());
          RootNavigation.goBack();
          return;
        }

        //todo make this an actual move previous action even tho implementation is same?
        dispatch({
          type: MOVE_NEXT,
          nextStep: previousStep,
        });

        if (previousStep.ComponentName === 'air' || previousStep.ComponentName === 'rail') {
          if (airReqComponentRedisKey) {
            RootNavigation.navigate(componentNameMap.airCloud, {
              legNumber: previousStep.LegNumber,
            });
          } else {
            RootNavigation.navigate(componentNameMap[previousStep.ComponentName], {
              legNumber: previousStep.LegNumber,
            });
          }
        } else {
          RootNavigation.navigate(componentNameMap[previousStep.ComponentName]);
        }
      }
    }
  };
};

export const movePreviousHotelDetail = () => {
  return { type: MOVE_PREVIOUS_HOTEL_DETAIL };
};
